<template>
  <div>
    <van-popup v-model="loading" :overlay="true"><div class="showLoading"><van-loading type="spinner" color="#fff" /><div class="note">数据加载中</div></div></van-popup>
  </div>
</template>

<script>
export default {
  name: "",
  components: {},
  props: {},
  data () {
    return {
       loading: true,
    }
  },
}
</script>
<style lang="scss" scoped>
    ::v-deep .van-popup{
        background-color: rgba(0, 0, 0, 0);
    }
  .showLoading {
        display: flex;
        align-items: center;
        justify-content: center;
        align-content: center;
        flex-wrap: wrap;
        width: 280px;
        height: 260px;
        overflow: hidden;
        background-color: rgba(0, 0, 0, 0.5);
        border-radius: 20px;
        padding-top: 20px;
        .note{
            width: 100%;
            height: 40px;
            padding-top: 30px;
            font-size: 30px;
            color: #fff;
            text-align: center;
        }
   }
</style>
